module.exports = __webpack_public_path__ + "static/img/IMG_0906.43ae00a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0906.jpeg
// module id = pAuZ
// module chunks = 0